import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
    setDocumentTitle('')
  }
  render() {
    return (
      <div className="policy">
        <h1>Room support</h1>
        Not open. Please waiting....
        </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport2/index.js